import { render, staticRenderFns } from "./edit-data.vue?vue&type=template&id=aeaf6a92&scoped=true&"
import script from "./edit-data.vue?vue&type=script&lang=js&"
export * from "./edit-data.vue?vue&type=script&lang=js&"
import style0 from "./edit-data.vue?vue&type=style&index=0&id=aeaf6a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaf6a92",
  null
  
)

export default component.exports